module.exports = __webpack_public_path__ + "img/ساده.b1a486b0.png";